import * as playerConstant from '../utils/playerConstants';
import {
  AAF_CONTENT_IS_AUDIO,
  AAF_CONTENT_IS_RADIO,
} from "../AAFPlayer/constants";
import logger from 'src/utils/logger/logger';

class TrackerManager {
  static trackers = [];
  static currentStreamContentType = null;

  constructor(trackers = []) {
    if (trackers.length > 0) {
      TrackerManager.trackers = trackers;
    }
  }

  static logTrackerFailure(operation, tracker, error) {
    let trackerName = tracker && tracker.name ? tracker.name : 'unknown-tracker';

    try {
      if (tracker && typeof tracker.getTrackerName === 'function') {
        trackerName = tracker.getTrackerName();
      }
    } catch (nameError) {
      // Keep the original tracker failure isolated even when its name cannot be read.
    }

    logger.error('Tracker operation failed', { operation, tracker: trackerName }, error);
  }

  static normalizeCurrentTime(currenttime){
    const maxTime = this.pgm && this.pgm.response && this.pgm.response.media && this.pgm.response.media.duration && this.pgm.response.media.duration.seconds;
    let time = parseInt(currenttime);
    if(!isNaN(maxTime) && time > maxTime){
      time = maxTime;
    }
    return time;
  }

  static setCurrentStreamContentType(
    streamContentType,
    fireOtherTrackers = false
  ) {
    // Only local value
    TrackerManager.currentStreamContentType = streamContentType;

    // Pass others trackers?
    if (fireOtherTrackers) {
      TrackerManager.trackers.forEach((tracker) => {
        if (typeof tracker.setCurrentStreamContentType === "function") {
          tracker.setCurrentStreamContentType(streamContentType);
        }
      });
    }
  }

  static setPlayhead(currentTime, streamType) {
    if (TrackerManager.isAudio()) return;

    if (TrackerManager.ignore(streamType)) {
      return;
    }
    TrackerManager.trackers.forEach(tracker => {
      if (typeof tracker.setPlayhead === 'function') {
        currentTime = this.normalizeCurrentTime(currentTime);
        tracker.setPlayhead(currentTime);
      }
    });
  }

  static addTracker(tracker = null) {
    if (tracker) TrackerManager.trackers.push(tracker);
  }

  static addTrackers(trackers = []) {
    if (trackers.length > 0) {
      TrackerManager.trackers = [...TrackerManager.trackers, ...trackers];
    }
  }

  static ignore(streamType) {
    if (
      streamType === playerConstant.AUDIO ||
      streamType === playerConstant.RADIO ||
      streamType === playerConstant.PLAYERIMAGE
    ) {
      return true;
    }
    return false;
  }

  static isAudio() {
    if (TrackerManager.currentStreamContentType === null) {
      return false;
    }

    let isAudioStream = false;
    switch (TrackerManager.currentStreamContentType) {
      case AAF_CONTENT_IS_AUDIO:
        isAudioStream = true;
        break;
      default:
        break;
    }

    return isAudioStream;
  }

  static setup(
    pgm = {} /* Playergetmedia response object */,
    extraParams = {},
    streamContentType = null,
    ContentStreamType,
  ) {
    switch (streamContentType) {
      // AUDIO
      case AAF_CONTENT_IS_AUDIO:
      case AAF_CONTENT_IS_RADIO:
        TrackerManager.trackers.forEach((tracker) => {
          if (typeof tracker.setupAudioTrack === "function") {
            tracker.setupAudioTrack(pgm, extraParams, streamContentType);
          }
        });
        break;
      // VIDEO
      default:
        this.pgm = pgm;
        logger.debug("TRACCCC", pgm);
        TrackerManager.trackers.forEach((tracker) => {
          if (typeof tracker.setup === "function") {
            try {
              tracker.setup(pgm, extraParams, streamContentType, ContentStreamType);
            } catch (err) {
              TrackerManager.logTrackerFailure('setup', tracker, err);
            }
          }
        });
        break;
    }

    // Reset stream anterior
    if (TrackerManager.currentStreamContentType !== null) {
      TrackerManager.setCurrentStreamContentType(null);
    }

    // Update stream content type
    if (streamContentType !== null) {
      TrackerManager.setCurrentStreamContentType(streamContentType);
    }
  }

  static setupExtraParams(extraParams = {}, isFallback) {
    if (TrackerManager.isAudio()) return;

    TrackerManager.trackers.forEach((tracker) => {
      if (typeof tracker.setupExtraParams === "function") {
        tracker.setupExtraParams(extraParams, isFallback);
      }
    });
  }

  static tick(currentTime, streamType) {
    if (TrackerManager.ignore(streamType)) {
      return;
    }
    TrackerManager.trackers.forEach(tracker => {
      if (typeof tracker.tick === 'function') {
        currentTime = this.normalizeCurrentTime(currentTime);
        tracker.tick(currentTime);
      }
    });
  }

  static startTicking(currentTime, streamType) {
    if (TrackerManager.ignore(streamType)) {
      return;
    }
    TrackerManager.trackers.forEach(tracker => {
      if (typeof tracker.startTicking === 'function') {
        currentTime = this.normalizeCurrentTime(currentTime);
        tracker.startTicking(currentTime);
      }
    });
  }

  static playerGetMedia(data, streamType) {
    if (TrackerManager.isAudio()) return;

    TrackerManager.trackers.forEach((tracker) => {
      if (typeof tracker.pgm === "function") {
        tracker.pgm(data);
      }
    });
  }

  static getDataPgm() {
    return this.pgm;
  }

  static pgm(currentTime, streamType) {
    if (TrackerManager.isAudio()) return;

    TrackerManager.trackers.forEach((tracker) => {
      if (typeof tracker.pgm === "function") {
        tracker.pgm();
      }
    });
  }

  static stopTicking(streamType) {
    if (TrackerManager.ignore(streamType)) {
      return;
    }

    TrackerManager.trackers.forEach((tracker) => {
      if (typeof tracker.stopTicking === "function") {
        tracker.stopTicking();
      }
    });
  }

  static bufferStart(streamType) {
    if (TrackerManager.isAudio()) return;

    // console.log("YouboraEvent bufferStart");
    if (TrackerManager.ignore(streamType)) {
      return;
    }

    TrackerManager.trackers.forEach((tracker) => {
      if (typeof tracker.bufferStart === "function") {
        tracker.bufferStart();
      }
    });
  }

  static bufferEnd(streamType) {
    if (TrackerManager.isAudio()) return;

    // console.log("YouboraEvent bufferEnd");

    if (TrackerManager.ignore(streamType)) {
      return;
    }

    TrackerManager.trackers.forEach((tracker) => {
      if (typeof tracker.bufferEnd === "function") {
        tracker.bufferEnd();
      }
    });
  }

  static playing(time, streamType) {
    if (TrackerManager.isAudio()) return;

    if (TrackerManager.ignore(streamType)) {
      return;
    }

    TrackerManager.trackers.forEach(tracker => {
      if (typeof tracker.playing === 'function') {
        time = this.normalizeCurrentTime(time);
        try {
          tracker.playing(time);
        } catch (err) {
          TrackerManager.logTrackerFailure('playing', tracker, err);
        }
      }
    });
  }

  static start(streamType) {
    if (TrackerManager.isAudio()) return;

    if (TrackerManager.ignore(streamType)) {
      return;
    }

    TrackerManager.trackers.forEach((tracker) => {
      if (typeof tracker.playing === "function") {
        tracker.start();
      }
    });
  }

  static play(currentTime, streamType) {
    if (TrackerManager.isAudio()) return;

    if (TrackerManager.ignore(streamType)) {
      return;
    }

    TrackerManager.trackers.forEach((tracker) => {
      if (typeof tracker.play === "function") {
        tracker.play();
      }
    });
  }

  static pause(currentTime, streamType) {
    if (TrackerManager.isAudio()) return;

    if (TrackerManager.ignore(streamType)) {
      return;
    }

    TrackerManager.trackers.forEach(tracker => {
      if (typeof tracker.pause === 'function') {
        currentTime = this.normalizeCurrentTime(currentTime);
        try {
          tracker.pause(currentTime);
        } catch (err) {
          TrackerManager.logTrackerFailure('pause', tracker, err);
        }
      }
    });
  }

  static resume(currentTime, streamType) {
    if (TrackerManager.isAudio()) return;

    if (TrackerManager.ignore(streamType)) {
      return;
    }
    TrackerManager.trackers.forEach(tracker => {
      if (typeof tracker.resume === 'function') {
        currentTime = this.normalizeCurrentTime(currentTime);
        try {
          tracker.resume(currentTime);
        } catch (err) {
          TrackerManager.logTrackerFailure('resume', tracker, err);
        }
      }
    });
  }

  static seek(seek, streamType) {
    if (TrackerManager.isAudio()) return;

    if (TrackerManager.ignore(streamType)) {
      return;
    }

    TrackerManager.trackers.forEach((tracker) => {
      logger.debug("==>tracker manager seek ....");
      logger.debug(tracker);
      if (typeof tracker.seek === 'function') {
        if (tracker.name === 'dashboard') {
          seek = this.normalizeCurrentTime(seek);
          tracker.seek(seek);
        } else {
          let currentTime = seek.seek_start;
          if(typeof seek === 'object' && seek.hasOwnProperty('seek_end')){
            currentTime = seek.seek_end;
          }
          currentTime = this.normalizeCurrentTime(currentTime);
          tracker.seek(currentTime);
        }
      }
    });
  }
  /*
    Se agrega urlStop que es la url para el track
    para asegurar que realmente sea la url de stop que corresponde al
    contenido en el que se esta haciendo stop
    curTime, TrackerManager.props.player.streamType, stopUrl, isLive
  */
  static stop(currentTime, streamType, urlStop, isLive, onlyTrackers = null) {
    if (TrackerManager.isAudio()) return;

    if (TrackerManager.ignore(streamType)) {
      return;
    }

    TrackerManager.trackers.forEach((tracker) => {
      if (Array.isArray(onlyTrackers)) {
        if (typeof tracker.getTrackerName === "function") {
          if (onlyTrackers.indexOf(tracker.getTrackerName()) !== -1) {
            currentTime = this.normalizeCurrentTime(currentTime);
            try {
              tracker.stop(currentTime, isLive, urlStop);
            } catch (err) {
              TrackerManager.logTrackerFailure('stop', tracker, err);
            }
          }
        }
      } else if (typeof tracker.stop === 'function') {
        currentTime = this.normalizeCurrentTime(currentTime);
        try {
          tracker.stop(currentTime, isLive, urlStop);
        } catch (err) {
          TrackerManager.logTrackerFailure('stop', tracker, err);
        }
      }
    });
  }

  static bitRateChange(bitrate, bandwidth, time, streamType) {
    if (TrackerManager.isAudio()) return;

    if (TrackerManager.ignore(streamType)) {
      return;
    }

    TrackerManager.trackers.forEach(tracker => {
      if (typeof tracker.bitRateChange === 'function') {
        time = this.normalizeCurrentTime(time);
        tracker.bitRateChange(bitrate, bandwidth, time);
      }
    });
  }

  static audioChange(currentTime, streamType) {
    if (TrackerManager.isAudio()) return;

    if (TrackerManager.ignore(streamType)) {
      return;
    }

    TrackerManager.trackers.forEach(tracker => {
      if (typeof tracker.audioChange === 'function') {
        currentTime = this.normalizeCurrentTime(currentTime);
        tracker.audioChange(currentTime);
      }
    });
  }

  static episodeChange(currentTime, streamType) {
    if (TrackerManager.isAudio()) return;

    if (TrackerManager.ignore(streamType)) {
      return;
    }

    TrackerManager.trackers.forEach(tracker => {
      if (typeof tracker.episodeChange === 'function') {
        currentTime = this.normalizeCurrentTime(currentTime);
        tracker.episodeChange(currentTime);
      }
    });
  }

  static subtitleChange(currentTime, streamType) {
    if (TrackerManager.isAudio()) return;

    if (TrackerManager.ignore(streamType)) {
      return;
    }

    TrackerManager.trackers.forEach(tracker => {
      if (typeof tracker.subtitleChange === 'function') {
        currentTime = this.normalizeCurrentTime(currentTime);
        tracker.subtitleChange(currentTime);
      }
    });
  }

  static leaveContent(currentTime, streamType) {
    if (TrackerManager.isAudio()) return;

    if (TrackerManager.ignore(streamType)) {
      return;
    }

    TrackerManager.trackers.forEach(tracker => {
      if (typeof tracker.leaveContent === 'function') {
        currentTime = this.normalizeCurrentTime(currentTime);
        tracker.leaveContent(currentTime);
      }
    });
  }

  static leaveApp(currentTime, streamType) {
    if (TrackerManager.isAudio()) return;

    if (TrackerManager.ignore(streamType)) {
      return;
    }

    TrackerManager.trackers.forEach(tracker => {
      if (typeof tracker.leaveApp === 'function') {
        currentTime = this.normalizeCurrentTime(currentTime);
        tracker.leaveApp(currentTime);
      }
    });
  }

  static foward(currentTime, streamType) {
    if (TrackerManager.isAudio()) return;

    if (TrackerManager.ignore(streamType)) {
      return;
    }

    TrackerManager.trackers.forEach(tracker => {
      if (typeof tracker.foward === 'function') {
        currentTime = this.normalizeCurrentTime(currentTime);
        tracker.foward(currentTime);
      }
    });
  }

  static rewind(currentTime, streamType) {
    if (TrackerManager.isAudio()) return;

    if (TrackerManager.ignore(streamType)) {
      return;
    }

    TrackerManager.trackers.forEach(tracker => {
      if (typeof tracker.rewind === 'function') {
        currentTime = this.normalizeCurrentTime(currentTime);
        tracker.rewind(currentTime);
      }
    });
  }

  static foward30(currentTime, streamType) {
    if (TrackerManager.isAudio()) return;

    if (TrackerManager.ignore(streamType)) {
      return;
    }

    TrackerManager.trackers.forEach(tracker => {
      if (typeof tracker.foward30 === 'function') {
        currentTime = this.normalizeCurrentTime(currentTime);
        tracker.foward30(currentTime);
      }
    });
  }

  static rewind30(currentTime, streamType) {
    if (TrackerManager.isAudio()) return;

    if (TrackerManager.ignore(streamType)) {
      return;
    }

    TrackerManager.trackers.forEach(tracker => {
      if (typeof tracker.rewind30 === 'function') {
        currentTime = this.normalizeCurrentTime(currentTime);
        tracker.rewind30(currentTime);
      }
    });
  }

  static exit(streamType) {
    if (TrackerManager.isAudio()) return;

    if (TrackerManager.ignore(streamType)) {
      return;
    }

    TrackerManager.trackers.forEach((tracker) => {
      if (typeof tracker.exit === "function") {
        tracker.exit();
      }
    });
  }

  /**
   * En el caso de un audioTrack, currentTime es el tiempo REAL de reproducción del track (NO es la duración del track).
   * Es decir, no cuenta el tiempo que de "no reproducción", por ejemplo cuando se hace seek o una pausa-resume
   * @param {*} currentTime
   * @param {*} streamType
   */
  static end(currentTime, streamType) {
    if (TrackerManager.ignore(streamType)) {
      return;
    }

    TrackerManager.trackers.forEach(tracker => {
      if (typeof tracker.end === 'function') {
        currentTime = this.normalizeCurrentTime(currentTime);
        tracker.end(currentTime);
      }
    });
  }

  static credits(currentTime, streamType) {
    if (TrackerManager.isAudio()) return;

    if (TrackerManager.ignore(streamType)) {
      return;
    }

    TrackerManager.trackers.forEach(tracker => {
      if (typeof tracker.credits === 'function') {
        currentTime = this.normalizeCurrentTime(currentTime);
        tracker.credits(currentTime);
      }
    });
  }

  static error({e, currentTime, streamType, errorCodeYoubora = "", errorMessageYoubora = ""}) {
    if (TrackerManager.ignore(streamType)) {
      return;
    }

    if (!e) {
      e = "666 [Generic Error on Player]";
    }
    const error = { stackTrace: e };

    TrackerManager.trackers.forEach(tracker => {
      if (typeof tracker.error === 'function') {
        currentTime = this.normalizeCurrentTime(currentTime);
        tracker.error({ message: error }, currentTime, errorCodeYoubora, errorMessageYoubora);
      }
    });

    logger.error("Tracked Error", error);
  }

  static errorContent({e, currentTime, streamType, errorCodeYoubora = "", errorMessageYoubora = ""}) {
    if (TrackerManager.isAudio()) return;

    if (TrackerManager.ignore(streamType)) {
      return;
    }

    if (!e) {
      e = "666 [Generic Error on Player]";
    }
    const error = { stackTrace: e };

    TrackerManager.trackers.forEach(tracker => {
      if (typeof tracker.errorContent === 'function') {
        currentTime = this.normalizeCurrentTime(currentTime);
        tracker.errorContent({ message: error }, currentTime, errorCodeYoubora, errorMessageYoubora);
      }
    });

    logger.error("Tracked  VOD Error", error);
  }

  static errorLive({e, currentTime, streamType, errorCodeYoubora = "", errorMessageYoubora = ""}) {
    if (TrackerManager.isAudio()) return;

    if (TrackerManager.ignore(streamType)) {
      return;
    }

    if (!e) {
      e = "666 [Generic Error on Player]";
    }
    const error = { stackTrace: e };

    TrackerManager.trackers.forEach(tracker => {
      if (typeof tracker.errorLive === 'function') {
        currentTime = this.normalizeCurrentTime(currentTime);
        tracker.errorLive({ message: error }, currentTime, errorCodeYoubora, errorMessageYoubora);
      }
    });

    logger.error("Tracked  VOD Error", error);
  }

  static apiError(content) {
    if (TrackerManager.isAudio()) return;

    //console.error('[APIERROR] TrackerManager > apiError content: ', content);
    let error = { message: content };
    TrackerManager.trackers.forEach((tracker) => {
      if (typeof tracker.apiError === "function") {
        tracker.apiError(content);
      }
    });
    logger.error("Tracked  api_error", error);
  }

  static playingFallback(params, err) {
    if (TrackerManager.isAudio()) return;

    TrackerManager.trackers.forEach((tracker) => {
      if (typeof tracker.playingFallback === "function") {
        tracker.playingFallback(params, err);
      }
    });
  }

  static fallbackError(params, err, url) {
    if (TrackerManager.isAudio()) return;

    TrackerManager.trackers.forEach((tracker) => {
      if (typeof tracker.playingFallback === "function") {
        tracker.fallbackError(params, err, url);
      }
    });
  }

  static startPlayFalled() {
    if (TrackerManager.isAudio()) return;

    TrackerManager.trackers.forEach((tracker) => {
      if (typeof tracker.startPlayFalled === "function") {
        tracker.startPlayFalled();
      }
    });
  }

  static resetTimePlaying() {
    TrackerManager.trackers.forEach((tracker) => {
      if (typeof tracker.resetTimePlaying === "function") {
        tracker.resetTimePlaying();
      }
    });
  }

  static startTimePlaying() {
    TrackerManager.trackers.forEach((tracker) => {
      if (typeof tracker.startTimePlaying === "function") {
        tracker.startTimePlaying();
      }
    });
  }

  static pauseTimePlaying() {
    TrackerManager.trackers.forEach((tracker) => {
      if (typeof tracker.pauseTimePlaying === "function") {
        tracker.pauseTimePlaying();
      }
    });
  }

  static getAudioTimePlaying() {
    let timePlaying = 0;
    let _done = false;
    TrackerManager.trackers.forEach((tracker) => {
      // El primero que encuentre :/, pero por ahora sólo se usa en audio
      if (typeof tracker.getTimePlaying === "function") {
        if (!_done) {
          timePlaying = tracker.getTimePlaying();
          _done = true;
        }
      }
    });

    return timePlaying;
  }
}

export default TrackerManager;



// WEBPACK FOOTER //
// ./src/utils/TrackerManager.js